import L from 'leaflet';

export const OSM_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION = '&copy; OpenStreetMap contributors';

/** Centro aproximado de Perú */
export const DEFAULT_MAP_CENTER = [-9.19, -75.015];
export const DEFAULT_MAP_ZOOM = 6;
export const PICKER_DEFAULT_ZOOM = 14;

export const addOsmTileLayer = (map) =>
  L.tileLayer(OSM_TILE_URL, {
    maxZoom: 19,
    attribution: OSM_ATTRIBUTION,
  }).addTo(map);

export const createRentahabPinIcon = () =>
  L.divIcon({
    className: '',
    html: `<div class="rentahab-map-pin"><div class="rentahab-map-pin-dot"></div><div class="rentahab-map-pin-pulse"></div></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

export const formatCoordinates = (latitude, longitude) => {
  if (latitude == null || longitude == null) return 'Sin ubicación';
  return `${Number(latitude).toFixed(6)}, ${Number(longitude).toFixed(6)}`;
};

export const hasValidCoordinates = (latitude, longitude) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  return Number.isFinite(lat) && Number.isFinite(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
};
